/**
 * CTA Section Component
 * 
 * Reusable call-to-action section for pages (except Contact page).
 * Encourages users to reach out and discuss their logistics needs.
 * 
 * DESIGN STANDARDS:
 * - Navy background (bg-primary) with white text
 * - White accent button for maximum contrast
 * - Consistent spacing: py-20
 * - Should appear above Footer on all pages except Contact
 * 
 * @component
 * @example
 * ```tsx
 * <CTASection />
 * ```
 */

import { memo } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const CTASection = memo(() => {
  return (
    <section 
      className="py-20 bg-primary text-primary-foreground" 
      aria-labelledby="cta-heading"
    >
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 
            id="cta-heading" 
            className="text-3xl md:text-4xl font-medium text-primary-foreground mb-6 font-newsreader"
          >
            Ready to Work With Us?
          </h2>
          <p className="text-xl text-primary-foreground/90 mb-8 leading-relaxed">
            Let's discuss how we can optimize your logistics and help your business grow.
          </p>
          <Button
            size="lg"
            className="bg-white hover:bg-white/90 text-primary font-medium text-lg px-12 shadow-lg hover:shadow-xl transition-all"
            asChild
          >
            <Link to="/contact">
              Get in Touch
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
});

CTASection.displayName = "CTASection";
